/* eslint-disable import/no-unresolved */
/* eslint-disable import/order */
// example (SVGR component via alias)
// import ArrowUp from '@icons/arrow_up.svg'
// export const Icons = { ArrowUp }

import AddDocument from '@icons/AddDocument.svg'
import AddMenu from '@icons/AddMenu.svg'
import AlphaLogo from '@icons/AlphaLogo.svg'
import ArrowDown from '@icons/ArrowDown.svg'
import ArrowLeft from '@icons/ArrowLeft.svg'
import ArrowRight from '@icons/ArrowRight.svg'
import AtSymbol from '@icons/AtSymbol.svg'
import BarChart from '@icons/BarChart.svg'
import Bell from '@icons/Bell.svg'
import Book from '@icons/Book.svg'
import BookOpenText from '@icons/BookOpenText.svg'
import BulletMenu from '@icons/BulletMenu.svg'
import Calendar from '@icons/Calendar.svg'
import CalendarPlus from '@icons/CalendarPlus.svg'
import Chat from '@icons/Chat.svg'
import Check from '@icons/Check.svg'
import CheckCircle from '@icons/CheckCircle.svg'
import CirclesFour from '@icons/CirclesFour.svg'
import CodeBrackets from '@icons/CodeBrackets.svg'
import CodeSlash from '@icons/CodeSlash.svg'
import ChevronDown from '@icons/ChevronDown.svg'
import ChevronLeft from '@icons/ChevronLeft.svg'
import ChevronRight from '@icons/ChevronRight.svg'
import ChevronUp from '@icons/ChevronUp.svg'
import Clock from '@icons/Clock.svg'
import ClockRecent from '@icons/ClockRecent.svg'
import ClockRefresh from '@icons/ClockRefresh.svg'
import Close from '@icons/Close.svg'
import ConferenceCall from '@icons/ConferenceCall.svg'
import Collapse from '@icons/Collapse.svg'
import Cube from '@icons/Cube.svg'
import Database from '@icons/Database.svg'
import DollarSign from '@icons/DollarSign.svg'
import DotsMenu from '@icons/DotsMenu.svg'
import Download from '@icons/Download.svg'
import DropdownArrow from '@icons/DropdownArrow.svg'
import DropdownToggle from '@icons/DropdownToggle.svg'
import EarningsEvent from '@icons/EarningsEvent.svg'
import EmptyBookmark from '@icons/EmptyBookmark.svg'
import EmptyDocument from '@icons/EmptyDocument.svg'
import EmptySend from '@icons/EmptySend.svg'
import EmptySquare from '@icons/EmptySquare.svg'
import ExclamationCircle from '@icons/ExclamationCircle.svg'
import Expand from '@icons/Expand.svg'
import ExternalLink from '@icons/ExternalLink.svg'
import Eye from '@icons/Eye.svg'
import FileStack from '@icons/FileStack.svg'
import Filter from '@icons/Filter.svg'
import FirstTake from '@icons/FirstTake.svg'
import Folder from '@icons/Folder.svg'
import FolderLock from '@icons/FolderLock.svg'
import FolderShared from '@icons/FolderShared.svg'
import Funnel from '@icons/Funnel.svg'
import Globe from '@icons/Globe.svg'
import Grid from '@icons/Grid.svg'
import GrowthChart from '@icons/GrowthChart.svg'
import InfoCircle from '@icons/InfoCircle.svg'
import InfoTriangle from '@icons/InfoTriangle.svg'
import LineChart from '@icons/LineChart.svg'
import Link from '@icons/Link.svg'
import LinkSimple from '@icons/LinkSimple.svg'
import Lightbulb from '@icons/Lightbulb.svg'
import LiveUrl from '@icons/LiveUrl.svg'
import Magic from '@icons/Magic.svg'
import Mail from '@icons/Mail.svg'
import MeetingAgent from '@icons/MeetingAgent.svg'
import Megaphone from '@icons/Megaphone.svg'
import MultipleDocument from '@icons/MultipleDocument.svg'
import MultipleFolder from '@icons/MultipleFolder.svg'
import NavbarMenu from '@icons/NavbarMenu.svg'
import NewMeeting from '@icons/NewMeeting.svg'
import Newspaper from '@icons/Newspaper.svg'
import OpenFolder from '@icons/OpenFolder.svg'
import Paperclip from '@icons/Paperclip.svg'
import Pencil from '@icons/Pencil.svg'
import Pin from '@icons/Pin.svg'
import Plus from '@icons/Plus.svg'
import Podcast from '@icons/Podcast.svg'
import PressRelease from '@icons/PressRelease.svg'
import QuestionCircle from '@icons/QuestionCircle.svg'
import Record from '@icons/Record.svg'
import Refresh from '@icons/Refresh.svg'
import Reload from '@icons/Reload.svg'
import ReplyArrow from '@icons/ReplyArrow.svg'
import Search from '@icons/Search.svg'
import SearchMenu from '@icons/SearchMenu.svg'
import Send from '@icons/Send.svg'
import SettingFolder from '@icons/SettingFolder.svg'
import Share from '@icons/Share.svg'
import ShareNodes from '@icons/ShareNodes.svg'
import Shuffle from '@icons/Shuffle.svg'
import SoundWave from '@icons/SoundWave.svg'
import Sparkle from '@icons/Sparkle.svg'
import SparkleV2 from '@icons/SparkleV2.svg'
import Stack from '@icons/Stack.svg'
import Stop from '@icons/Stop.svg'
import Table from '@icons/Table.svg'
import TextDocument from '@icons/TextDocument.svg'
import Transcript from '@icons/Transcript.svg'
import Trash from '@icons/Trash.svg'
import Upload from '@icons/Upload.svg'
import UploadDocument from '@icons/UploadDocument.svg'
import Youtube from '@icons/youtube.svg'
import Warning from '@icons/Warning.svg'
import WarningCircle from '@icons/WarningCircle.svg'
import CursorClick from '@icons/CursorClick.svg'
import FileSearch from '@icons/FileSearch.svg'
import ChatCircleDots from '@icons/ChatCircleDots.svg'
import Pause from '@icons/Pause.svg'
import Play from '@icons/Play.svg'
import Repeat from '@icons/Repeat.svg'
import ChartPie from '@icons/ChartPie.svg'

export const Icons = {
  AddDocument,
  ArrowDown,
  CirclesFour,
  CodeBrackets,
  CodeSlash,
  CursorClick,
  Calendar,
  CalendarPlus,
  Pause,
  Play,
  ChartPie,
  WarningCircle,
  FileSearch,
  ChatCircleDots,
  AddMenu,
  AlphaLogo,
  ArrowLeft,
  ArrowRight,
  AtSymbol,
  BarChart,
  Bell,
  Book,
  BookOpenText,
  BulletMenu,
  Chat,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clock,
  ClockRecent,
  ClockRefresh,
  Close,
  ConferenceCall,
  Collapse,
  Cube,
  Database,
  DollarSign,
  DotsMenu,
  Download,
  DropdownArrow,
  DropdownToggle,
  EarningsEvent,
  EmptyBookmark,
  EmptyDocument,
  EmptySend,
  EmptySquare,
  ExclamationCircle,
  Expand,
  ExternalLink,
  Eye,
  FileStack,
  Filter,
  FirstTake,
  Folder,
  FolderLock,
  FolderShared,
  Funnel,
  Globe,
  Grid,
  GrowthChart,
  InfoCircle,
  InfoTriangle,
  LineChart,
  Link,
  LinkSimple,
  Lightbulb,
  LiveUrl,
  Magic,
  Mail,
  MeetingAgent,
  Megaphone,
  MultipleDocument,
  MultipleFolder,
  NavbarMenu,
  NewMeeting,
  Newspaper,
  OpenFolder,
  Paperclip,
  Pencil,
  Pin,
  Plus,
  Podcast,
  PressRelease,
  QuestionCircle,
  Record,
  Refresh,
  Reload,
  Repeat,
  ReplyArrow,
  Search,
  SearchMenu,
  Send,
  SettingFolder,
  Share,
  ShareNodes,
  Shuffle,
  SoundWave,
  Sparkle,
  SparkleV2,
  Stack,
  Stop,
  Table,
  TextDocument,
  Transcript,
  Trash,
  Upload,
  UploadDocument,
  Youtube,
  Warning,
}
